import React, { useEffect } from 'react';
import { useReport } from '../../DataStore/ReportContext';
import ActivityLoader from '../Common/ActivityLoader';
import Notification from '../Common/Notification';
import functions from '../../util/functions';

const TrialBalance = () => {
    const { trialBalance, getTrialBalance } = useReport();

    useEffect(() => {
        getTrialBalance();
    }, []);

    if (!trialBalance) return <ActivityLoader />;
    if (trialBalance === "404") return <Notification message="Trial balance could not be loaded" />;

    return (
        <div className="card border-0 shadow-sm mt-4" style={{ borderRadius: '16px', backgroundColor: '#fff' }}>
            <style>{`
                .tb-table thead th { 
                    background: #F8FAFC; 
                    color: #64748B; 
                    font-size: 11px; 
                    text-transform: uppercase; 
                    letter-spacing: 0.05em;
                    border: none;
                    padding: 12px 20px;
                }
                .tb-category-row { 
                    background: #F1F5F9; 
                    color: #1E293B; 
                    font-weight: 800; 
                    font-size: 13px;
                }
                .tb-account-cell { padding-left: 35px !important; color: #475569; font-weight: 500; }
                .tb-amount { font-weight: 700; color: #1E293B; }
                .tb-total-row { background: #F8FAFC; border-top: 2px solid #E2E8F0; }
                .status-badge { font-size: 10px; padding: 4px 10px; border-radius: 6px; font-weight: 800; }
            `}</style>


            <div className="rac-head d-flex align-items-center justify-content-between">
                    <div className="d-flex align-items-center" style={{ gap: 12 }}>
                      <div className="rac-headIcon">
                        <i className="fa fa-book-open" />
                      </div>
                      <div>
                        <h6 className="rac-title">Current Trial Balance</h6>
                        <div className="rac-sub">Summary of all ledger balances</div>
                      </div>
                    </div>
            
                    {trialBalance.balanced ? (
                    <span className="status-badge" style={{ backgroundColor: '#ECFDF5', color: '#059669' }}>
                            <i className="fas fa-check-circle mr-1"></i> BALANCED
                        </span>
                    ) : (
                        <span className="status-badge" style={{ backgroundColor: '#FEF2F2', color: '#DC2626' }}>
                            <i className="fas fa-exclamation-triangle mr-1"></i> UNBALANCED
                        </span>
                    )}
                  </div>



            <div className="card-body p-0">
                <div className="table-responsive overflow-auto" style={{ maxHeight: '400px' }}>
                    <table className="table tb-table mb-0">
                        <thead className="sticky-top">
                            <tr>
                                <th>Category / Account</th>
                                <th className="text-right">Debit (Dr)</th>
                                <th className="text-right">Credit (Cr)</th>
                            </tr>
                        </thead>
                        <tbody>
                            {functions.isObject(trialBalance.trial_balance) && 
                              Object.entries(trialBalance.trial_balance).map(([category, accounts]) => (
                                <React.Fragment key={category}>
                                    <tr>
                                        <td colSpan="3" className="tb-category-row py-2 px-4">
                                            {category}
                                        </td>
                                    </tr>
                                    {accounts.map((account, index) => (
                                        <tr key={index}>
                                            <td className="tb-account-cell">{account.account}</td>
                                            <td className="text-right tb-amount">
                                                {account.total_debit > 0 ? functions.numberFormat(account.total_debit) : '-'}
                                            </td>
                                            <td className="text-right tb-amount">
                                                {account.total_credit > 0 ? functions.numberFormat(account.total_credit) : '-'}
                                            </td>
                                        </tr>
                                    ))}
                                </React.Fragment>
                            ))}
                        </tbody>
                        <tfoot className="sticky-bottom tb-total-row">
                            <tr>
                                <th className="pl-4 py-3" style={{fontSize: '13px'}}>GRAND TOTAL</th>
                                <th className="text-right py-3 pr-4 text-primary" style={{ fontSize: '14px' }}>
                                    {functions.numberFormat(trialBalance.totals.total_debit)}
                                </th>
                                <th className="text-right py-3 pr-4 text-primary" style={{ fontSize: '14px' }}>
                                    {functions.numberFormat(trialBalance.totals.total_credit)}
                                </th>
                            </tr>
                        </tfoot>
                    </table>
                </div>
            </div>
        </div>
    );
};

export default TrialBalance;